import { render } from "./MinusIcon.vue?vue&type=template&id=b6e0513c"
const script = {}

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__